import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useApi } from "../../../../hooks/useApi";
import ToggleBtn from "../../../Button/ToggleBtn";
import LineBox from "../../../DefaultStyles/LineBox";
import Loader from "../../../DefaultStyles/Loader";
import AlertModal from "../../../Modal/AlertModal";
import ManagerPwInputModal from "../../../Modal/ManagerPwInputModal";
import Table, { TableBody, TableBodyItem } from "../../../Table/Table";
import MaintenanceTimeModal from "./ManageServer/MaintenanceTimeModal";
import { OptionType } from "../../../Filters/DropDown";
import LineBtn from "../../../Button/LineBtn";

interface IServer {
  desc: string;
  id: number;
  isblock: number;
  lastupdate: string;
}

interface ManageServerProps {
  blockData?: IServer[];
  refetch: () => void;
}

export default function ManageBlock({ blockData, refetch }: ManageServerProps) {
  const [askModal, setAskModal] = useState({
    visible: false,
    blockType: 0,
  });
  const [pwInputModal, setPwInputModal] = useState(false);

  const [UpdateBlock, setUpdateBlock] = useState(false); // 서버 점검 업데이트 실행

  const tableHead = ["분류", "최근 업데이트 일시", "ON/OFF"];

  // 서버 점검 상태 업데이트 하기
  const { response, error, loading } = useApi({
    method: "post",
    url: UpdateBlock ? `version/block` : undefined,
    data: {
      id: askModal?.blockType,
    },
  });

  useEffect(() => {
    if (response?.status === 200 || response?.status === 201) {
      setUpdateBlock(false);
      setAskModal({
        ...askModal,
        blockType: 0,
      });
      refetch();
    }
  }, [response]);

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "상태를 업데이트 하는 데에 실패하였습니다.");
    }
  }, [error]);

  // useEffect(() => {
  //   setIsMaintenance(blockData?.maintenance === "0" ? false : true);
  // }, [blockData]);

  useEffect(() => {
    // console.log(UpdateBlock, isMaintenance, isChangeTime);
  }, [UpdateBlock]);

  return (
    <>
      <LineBox>
        <Table tableHeadData={tableHead}>
          <>
            {blockData?.map((d) => {
              return (
                <TableBody>
                  <TableBodyItem>{d?.desc}</TableBodyItem>

                  <TableBodyItem>
                    {dayjs(d?.lastupdate ?? undefined)?.format(
                      "YYYY-MM-DD HH:mm:ss"
                    )}
                  </TableBodyItem>
                  <TableBodyItem>
                    <ToggleBtn
                      check={Boolean(!d?.isblock)}
                      checkEvent={() => {
                        setAskModal({
                          visible: true,
                          blockType: d?.id,
                        });
                        // if (d?.isblock) {
                        //   setAskModal(true);
                        // } else {
                        //   setMainTenanceTimeModal(true);
                        // }
                      }}
                    />
                  </TableBodyItem>
                </TableBody>
              );
            })}
          </>
        </Table>
      </LineBox>

      {loading && <Loader />}

      {askModal.visible && (
        <AlertModal
          title={`상태를 변경합니다. `}
          cancelEvent={() =>
            setAskModal({
              visible: false,
              blockType: 0,
            })
          }
          confirmEvent={() => {
            setPwInputModal(true);
            setAskModal({
              ...askModal,
              visible: false,
            });
          }}
        />
      )}

      {/* 관리자 비밀번호 입력 */}
      {pwInputModal && (
        <ManagerPwInputModal
          closeEvent={() => setPwInputModal(false)}
          confirmEvent={() => {
            setUpdateBlock(true);
            setPwInputModal(false);
          }}
          confirmBtnText={"변경하기"}
        />
      )}
    </>
  );
}
